import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QrscannerComponent } from './qrscanner.component';
import { ToasterComponent } from '../toaster/toaster.component';
import { TranslateModule } from '@ngx-translate/core';
import { AlertsComponent } from 'src/app/components/alerts/alerts.component';



@NgModule({
  declarations: [QrscannerComponent],
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [QrscannerComponent],
  providers: [ToasterComponent, AlertsComponent]
})
export class QrscannerModule { }
